import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import '@/i18n'
import App from './App'
import { installContentProtection } from '@/lib/protectContent'

import { registerSW } from 'virtual:pwa-register'

// No-op stub when vite-plugin-pwa is missing; real SW when the plugin is active
registerSW({ immediate: true })
installContentProtection()

const root = document.getElementById('root')
if (!root) {
  throw new Error('Root element #root not found')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
